import React from "react";

import type { LegalSection } from "./legal.types";
import LegalPageLayout from "./LegalPageLayout";

const intro = ["p1"] as const;

/** Section order and shape; the prose lives under `cookiePolicy` in the legal namespace. */
const sections: LegalSection[] = [
	{ key: "whatAreCookies", paragraphs: ["p1"] },
	{ key: "howWeUseCookies", listItems: ["i1", "i2", "i3", "i4"], paragraphs: ["p1"] },
	{ key: "thirdPartyCookies", listItems: ["i1", "i2", "i3"], paragraphs: ["p1"] },
	{ key: "managingCookies", paragraphs: ["p1"] },
	{ key: "changesToPolicy", paragraphs: ["p1"] },
	{ key: "governingLawAndContact", paragraphs: ["p1"] }
];

const CookiePolicyPage = () => {
	return <LegalPageLayout intro={intro} page="cookiePolicy" sections={sections} />;
};

export default CookiePolicyPage;
